// extracted by mini-css-extract-plugin
export default {"wrapper":"ss6mxJES","header":"DxnHwJNj","title":"ntjv66FR","eta":"opx8bsJd"};